export default "__VITE_ASSET__7j1KiaFf__"